import http from '@/lib/http';
import { Message } from 'element-ui';

export default {

    async findCommentList(pageIndex, pageSize, sort, searchConditions) {
        try {
            let params = {
                pageIndex,
                pageSize,
                sort,
                ...searchConditions,
            };
            let res = await http.post('/api/discussion/search', params);
            if (res.success) {
                return res.data;
            } else {
                Message.error(res.message);
                return null;
            }
        } catch (err) {
            console.log(err);
        }
    },

    async deleteComment(id) {
        try {
            let res = await http.delete(`/api/discussion/${id}`);
            if (res.success) {
                return res.data;
            } else {
                Message.error(res.message);
                return null;
            }
        } catch (err) {
            console.log(err);
        }
    },
}
